import Compensation from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Compensation'
import type Store from 'modules/attendance/components/ClockIn/Store'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'

import BankOfHoursBreakdown from './BankOfHoursBreakdown'
import TimeBreakdown from './TimeBreakdown'

interface BankOfHoursPanelProps {
  selectedContext: string
  store: Store
  timeSheetData: ReturnType<typeof useTimesheetData>
}

const BankOfHoursPanel = ({ selectedContext, store, timeSheetData }: BankOfHoursPanelProps) => {
  const { timeBlocksBalance } = timeSheetData

  switch (selectedContext) {
    case 'bank_of_hours':
      return <BankOfHoursBreakdown timeSheetData={timeSheetData} />
    case 'worked_hours':
      return <TimeBreakdown store={store} timeSheetData={timeSheetData} />

    case 'compensation':
      return <Compensation timeBlocksBalance={timeBlocksBalance} />
    default:
      throw new Error(`Unhandled SidePanelTab value: ${selectedContext}`)
  }
}

export default BankOfHoursPanel
